import apiService from './api';

class GalleryService {
    // Get all galleries for the current user
    async getUserGalleries() {
        return await apiService.get('/api/galleries');
    }

    // Get galleries shared with the current user
    async getSharedGalleries() {
        return await apiService.get('/api/galleries/shared');
    }

    // Get a specific gallery with videos
    async getGalleryWithVideos(galleryId) {
        return await apiService.get(`/api/galleries/${galleryId}`);
    }

    // Get a gallery by URL name (handles both public and private galleries)
    async getGalleryByUrlName(urlName) {
        return await apiService.get(`/api/public/galleries/${urlName}`);
    }

    // Create a new gallery
    async createGallery(galleryData) {
        return await apiService.post('/api/galleries', galleryData);
    }

    // Update an existing gallery
    async updateGallery(galleryId, galleryData) {
        return await apiService.put(`/api/galleries/${galleryId}`, galleryData);
    }

    // Delete a gallery
    async deleteGallery(galleryId) {
        return await apiService.delete(`/api/galleries/${galleryId}`);
    }

    // Auto-save: Create gallery with optional/empty fields
    async autoCreateGallery(data = {}) {
        return await apiService.post('/api/galleries/auto', data);
    }

    // Auto-save: Partial update (only provided fields)
    async patchGallery(galleryId, fields) {
        return await apiService.patch(`/api/galleries/${galleryId}`, fields);
    }

    // Video operations
    async addVideo(galleryId, videoData) {
        return await apiService.post(`/api/galleries/${galleryId}/videos`, videoData);
    }

    async removeVideo(galleryId, videoId) {
        return await apiService.delete(`/api/galleries/${galleryId}/videos/${videoId}`);
    }

    async bulkRemoveVideos(galleryId, videoIds) {
        return await apiService.post(`/api/galleries/${galleryId}/videos/bulk-delete`, { videoIds });
    }

    async updateVideo(galleryId, videoId, data) {
        return await apiService.patch(`/api/galleries/${galleryId}/videos/${videoId}`, data);
    }

    async reorderVideos(galleryId, videoIds) {
        return await apiService.put(`/api/galleries/${galleryId}/videos/reorder`, { videoIds });
    }

    // Invitation operations
    async addInvitation(galleryId, email, canEdit) {
        return await apiService.post(`/api/galleries/${galleryId}/invitations`, { email, canEdit });
    }

    async removeInvitation(galleryId, email) {
        return await apiService.delete(`/api/galleries/${galleryId}/invitations/${encodeURIComponent(email)}`);
    }

    async updateInvitation(galleryId, email, canEdit) {
        return await apiService.patch(`/api/galleries/${galleryId}/invitations/${encodeURIComponent(email)}`, { canEdit });
    }
}

// Create singleton instance
const galleryService = new GalleryService();
export default galleryService;
